"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#004864"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m18.62 1.47v17.53l2.69-2.69a1.47 1.47 0 1 1 2.08 2.08l-5.2 5.2a1.48 1.48 0 0 1 -2.08 0l-5.2-5.2a1.47 1.47 0 1 1 2.09-2.1l2.68 2.71v-17.53a1.47 1.47 0 0 1 2.94 0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m5.38 22.53v-17.53l-2.69 2.71a1.47 1.47 0 0 1 -2.08-2.08l5.2-5.2a1.48 1.48 0 0 1 2.08 0l5.2 5.2a1.47 1.47 0 1 1 -2.09 2.08l-2.68-2.71v17.53a1.47 1.47 0 0 1 -2.94 0z"
  })));
};

exports["default"] = _default;